// This is based on https://github.com/kapetan/text-width, but simplified

// You may need to mock this module out in the jest tests
const context = document.createElement('canvas').getContext('2d');

const getTextWidth = (str, opts) => {
  const options = {
    style: 'normal',
    variant: 'normal',
    weight: 'normal',
    size: 'medium',
    family: 'sans-serif',
    align: 'start',
    baseline: 'alphabetic',
    ...opts,
  };

  context.font = [
    options.style,
    options.variant,
    options.weight,
    typeof options.size === 'number' ? `${options.size}px` : options.size,
    options.family,
  ].join(' ');
  context.textAlign = options.align;
  context.textBaseline = options.baseline;

  return context.measureText(str).width;
};

export default getTextWidth;
